<template>
  <div class="hd-header">
    <header class="header">
      <div class="wrap flex">
        <div class="logo">
          <img src="../../assets/images/logo.png" alt="">
        </div>
        <div class="link">
          <router-link to="/" class="index" :class="{actived:currentPath=='/'}">首页</router-link>
          <router-link to="/settle" :class="{actived:currentPath=='/settle'}">个人/机构入驻</router-link>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  name: 'hd-header',
  data() {
    return {
      currentPath: this.$route.path
    }
  },
  created() {}
}

</script>
<style lang="scss" scoped>
.header {
  width: 100%;
  height: 72px;
  line-height: 72px;
  background-color: #2ebafe;
  color: #fff;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  .logo {
    width: 165px;
    float: left;
  }
  .link {
    width: 240px;
    margin-left: auto;
    &>a {
      position: relative;
    }
    .index {
      margin-right: 100px;
    }
    .actived:after {
      content: '';
      width: 80%;
      height: 2px;
      background: #fff;
      position: absolute;
      bottom: -8px;
      left: 10%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// hd-header.vue?40e3654c